export default function truncateText(str, maxLength = 20) {
  str = str ?? "";
  if (str?.length <= maxLength) {
    return str;
  }
  return str?.slice(0, maxLength - 3) + "...";
}
